import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c34d9bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "fs-4" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "fs-4" }
const _hoisted_8 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_9 = { class: "col" }
const _hoisted_10 = {
  key: 0,
  class: "list-group overflow-auto border border-1"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "fs-6 m-0" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "list-group"
}
const _hoisted_17 = { class: "list-group-item fst-italic" }
const _hoisted_18 = { class: "col-2 d-flex flex-column justify-content-center align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "arrow_right", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "arrow_left", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "col" }
const _hoisted_24 = {
  key: 0,
  class: "list-group overflow-auto border border-1"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "m-0" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "list-group"
}
const _hoisted_31 = { class: "list-group-item fst-italic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_alert_success = _resolveComponent("alert-success")!
  const _component_alert_error = _resolveComponent("alert-error")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('productChoice'),
        "help-text": _ctx.$t('labsDescription'),
        mb: 5,
        "show-refresh-button": "",
        onRefresh: this.reloadContent
      }, null, 8, ["title", "help-text", "onRefresh"]),
      _createVNode(_component_alert_success, {
        "show-if": _ctx.savedSuccessfully,
        class: "mb-3"
      }, null, 8, ["show-if"]),
      _createVNode(_component_alert_error, {
        exceptions: _ctx.exceptions,
        class: "mb-3"
      }, null, 8, ["exceptions"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('allLabs')), 1),
          _createVNode(_component_dp_form, {
            as: "form",
            onSubmit: _ctx.filterProductBrands,
            novalidate: ""
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_input_text, {
                  modelValue: _ctx.searchQuery,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  modelModifiers: { trim: true },
                  onInput: _ctx.filterProductBrands,
                  class: "d-flex flex-grow-1",
                  label: _ctx.$t('search'),
                  name: "search",
                  errors: errors
                }, null, 8, ["modelValue", "onInput", "label", "errors"]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearSearchQuery && _ctx.clearSearchQuery(...args)), ["prevent"])),
                  type: "reset",
                  class: "btn-close me-3 mb-3 position-absolute end-0"
                })
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('selectedLabs')), 1)
        ])
      ]),
      _createVNode(_component_BaseSpinner, {
        spin: !this.isReady,
        "spinner-class": "my-5"
      }, null, 8, ["spin"]),
      (this.isReady)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (Object.keys(_ctx.filteredProductBrands).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProductBrands, (productBrand) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: productBrand.code,
                        onClick: ($event: any) => (_ctx.addToBrandsToAdd(productBrand.code)),
                        class: _normalizeClass(["list-group-item list-group-item-action d-flex justify-content-between align-items-center border-white", {active: _ctx.brandsToAdd.includes(productBrand.code)}])
                      }, [
                        _createElementVNode("p", _hoisted_12, _toDisplayString(productBrand.description), 1),
                        _createElementVNode("button", {
                          class: "btn btn-icon btn-sm btn-secondary",
                          onClick: ($event: any) => (_ctx.addToStarterBrands(productBrand.code))
                        }, _hoisted_15, 8, _hoisted_13)
                      ], 10, _hoisted_11))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('noBrandsFound')), 1)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "btn btn-icon btn-primary mb-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addToStarterBrands && _ctx.addToStarterBrands(...args)))
              }, _hoisted_20),
              _createElementVNode("button", {
                class: "btn btn-icon btn-primary",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removeFromStarterBrands && _ctx.removeFromStarterBrands(...args)))
              }, _hoisted_22)
            ]),
            _createElementVNode("div", _hoisted_23, [
              (Object.keys(_ctx.starterBrandOverview).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.starterBrandOverview, (starterBrand) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: starterBrand.code,
                        onClick: ($event: any) => (_ctx.addToBrandsToRemove(starterBrand.code)),
                        class: _normalizeClass(["list-group-item list-group-item-action d-flex justify-content-between align-items-center border-white", {active: _ctx.brandsToRemove.includes(starterBrand.code)}])
                      }, [
                        _createElementVNode("p", _hoisted_26, _toDisplayString(starterBrand.description), 1),
                        _createElementVNode("button", {
                          class: "btn btn-icon btn-sm btn-danger",
                          onClick: ($event: any) => (_ctx.removeFromStarterBrands(starterBrand.code))
                        }, _hoisted_29, 8, _hoisted_27)
                      ], 10, _hoisted_25))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('noBrandsAdded')), 1)
                  ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}